module.exports = "  <!-- <section class=\"content\">\n      <div class=\"container-fluid\">\n          <div class=\"block-header\">\n              <router-outlet></router-outlet>\n          </div>\n      </div>\n  </section>\n<jaspero-confirmations [defaultSettings]=\"options\"></jaspero-confirmations> -->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main